/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Driver_CheckoutInputs */

const en_orders_logistics_driver_checkout = /** @type {(inputs: Orders_Logistics_Driver_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver Check-Out`)
};

const es_orders_logistics_driver_checkout = /** @type {(inputs: Orders_Logistics_Driver_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida del chofer`)
};

/**
* | output |
* | --- |
* | "Driver Check-Out" |
*
* @param {Orders_Logistics_Driver_CheckoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_driver_checkout = /** @type {((inputs?: Orders_Logistics_Driver_CheckoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Driver_CheckoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_driver_checkout(inputs)
	return es_orders_logistics_driver_checkout(inputs)
});